module.exports = __webpack_public_path__ + "img/banner.fbc5a250.jpg";